/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

var props = {
  align: {
    type: String,
    validator: function validator(val) {
      if (!val) return true;
      return ["left", "center", "right"].includes(val);
    }
  },
  autoWidth: Boolean,
  decimalPlaces: {
    type: Number,
    "default": void 0
  },
  disabled: Boolean,
  format: {
    type: Function
  },
  inputProps: {
    type: Object
  },
  label: {
    type: [String, Function]
  },
  largeNumber: Boolean,
  max: {
    type: [String, Number],
    "default": Infinity
  },
  min: {
    type: [String, Number],
    "default": -Infinity
  },
  placeholder: {
    type: String,
    "default": void 0
  },
  readonly: Boolean,
  size: {
    type: String,
    "default": "medium",
    validator: function validator(val) {
      if (!val) return true;
      return ["small", "medium", "large"].includes(val);
    }
  },
  status: {
    type: String,
    validator: function validator(val) {
      if (!val) return true;
      return ["default", "success", "warning", "error"].includes(val);
    }
  },
  step: {
    type: [String, Number],
    "default": 1
  },
  suffix: {
    type: [String, Function]
  },
  theme: {
    type: String,
    "default": "row",
    validator: function validator(val) {
      if (!val) return true;
      return ["column", "row", "normal"].includes(val);
    }
  },
  tips: {
    type: [String, Function]
  },
  value: {
    type: [String, Number],
    "default": void 0
  },
  defaultValue: {
    type: [String, Number]
  },
  onBlur: Function,
  onChange: Function,
  onEnter: Function,
  onFocus: Function,
  onKeydown: Function,
  onKeypress: Function,
  onKeyup: Function,
  onValidate: Function
};

export { props as default };
//# sourceMappingURL=props.js.map
